import { useState } from 'react'
import { Link, NavLink } from 'react-router-dom'
import { APP_LOGIN_URL } from '@/config'

const navigation = [
  { name: 'Home', href: '/' },
  { name: 'Features', href: '/features' },
  { name: 'Industries', href: '/industries' },
  { name: 'Pricing', href: '/pricing' },
]

export function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/80 backdrop-blur-xl border-b border-surface-200 safe-top">
      <nav className="mx-auto max-w-7xl section-padding" aria-label="Global">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <img src="/ledger-logo.svg" alt="Ledger" className="h-10 w-auto" />
          </Link>

          {/* Desktop navigation */}
          <div className="hidden md:flex items-center gap-8">
            {navigation.map((item) => (
              <NavLink
                key={item.name}
                to={item.href}
                end={item.href === '/'}
                className={({ isActive }) =>
                  `text-sm font-medium transition-colors relative pb-1 ${
                    isActive
                      ? 'text-surface-900 after:absolute after:bottom-0 after:left-0 after:right-0 after:h-0.5 after:rounded-full'
                      : 'text-surface-600 hover:text-surface-900'
                  }`
                }
                style={({ isActive }) => isActive ? { '--tw-after-bg': '#08C6EA' } as React.CSSProperties : {}}
              >
                {({ isActive }) => (
                  <>
                    {item.name}
                    {isActive && (
                      <span className="absolute bottom-0 left-0 right-0 h-0.5 rounded-full" style={{ backgroundColor: '#08C6EA' }} />
                    )}
                  </>
                )}
              </NavLink>
            ))}
          </div>

          {/* Desktop CTA — forward to app */}
          <div className="hidden md:flex items-center gap-4">
            <a
              href={APP_LOGIN_URL}
              className="text-sm font-medium text-surface-600 hover:text-surface-900"
            >
              Log In
            </a>
            <a
              href={APP_LOGIN_URL}
              className="btn btn-primary text-sm py-2.5"
            >
              Sign Up
            </a>
          </div>

          {/* Mobile menu button */}
          <button
            type="button"
            className="md:hidden p-2 text-surface-600 hover:text-surface-900"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            <span className="sr-only">Open menu</span>
            {mobileMenuOpen ? (
              <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
              </svg>
            ) : (
              <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
              </svg>
            )}
          </button>
        </div>

        {/* Mobile menu */}
        {mobileMenuOpen && (
          <div className="md:hidden py-4 border-t border-surface-200 animate-slide-down">
            <div className="space-y-1">
              {navigation.map((item) => (
                <Link
                  key={item.name}
                  to={item.href}
                  className="block px-4 py-3 text-base font-medium text-surface-600 hover:text-surface-900 hover:bg-surface-50 rounded-lg transition-colors"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  {item.name}
                </Link>
              ))}
            </div>
            <div className="mt-4 pt-4 border-t border-surface-200 space-y-2 px-4">
              <a
                href={APP_LOGIN_URL}
                className="block w-full text-center py-2 text-surface-600 hover:text-surface-900"
                onClick={() => setMobileMenuOpen(false)}
              >
                Log In
              </a>
              <a
                href={APP_LOGIN_URL}
                className="block w-full btn btn-primary text-center"
                onClick={() => setMobileMenuOpen(false)}
              >
                Sign Up
              </a>
            </div>
          </div>
        )}
      </nav>
    </header>
  )
}
